export const SET_EDIT_MULTI_LOADING = 'SET_EDIT_MULTI_LOADING'
export const SET_EDIT_MULTI_DATA = 'SET_EDIT_MULTI_DATA'
export const SET_EDIT_MULTI_DATA_ERROR = 'SET_EDIT_MULTI_DATA_ERROR'
